import { OnInit, Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Location } from '@angular/common';
import { FormBuilder, FormControl, FormGroup } from '@angular/forms';
import { BoobleModalService } from 'booble-modal';

import { OrdersService } from 'src/app/shared/services/orders.service';
import { InboundOrderDto } from 'src/app/domain/models/dto/inbound-order.dto';

import { NotifierService } from 'angular-notifier';
import { MatTabChangeEvent } from '@angular/material/tabs';
import { tabMappingsHistoryAdmin } from '../home/utils/tabMapping';
import {
  ETableInProgressStatusFlow,
  ETableFinishedStatusFlow,
  OrderStatusTypes,
  EOrderStatusFlow,
} from 'src/app/domain/enums/order-status-types.enum';
import { ExchangeOrdersComponent } from './modals/exchange-orders/exchange-orders.component';
import { ExchangeDocumentsCheckComponent } from './modals/exchange-documents-check/exchange-documents-check.component';
import { RouteModalService } from 'src/app/shared/services/route-modal.service';
import { ResponseTableModel } from 'src/app/domain/models/response-table.model';
import { Moedas } from 'src/app/domain/constants/moeda.constant';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { BankAccountService } from 'src/app/shared/services/bank-account.service';
 
@Component({
  selector: 'app-orders-history',
  templateUrl: './orders-history.component.html',
  styleUrls: ['./orders-history.component.scss'],
})
export class OrdersHistoryComponent implements OnInit {
  statusFlowOptions: any = [
    ...Object.entries(ETableInProgressStatusFlow),
    ...Object.entries(ETableFinishedStatusFlow),
  ].map(([key, value]) => ({
    value: key,
    label: value,
  }));

  tenant: string = '';
  rType: string = '';
  status: string = '';
  tableTitle: string = '';
  loading: boolean = false;
  pageSize: number = 10;
  pageNumber: number = 0;
  totalElements: number;

  modal;
  tableDisplayedColumns: string[];
  private readonly notifier: NotifierService;
  public orders: ResponseTableModel<InboundOrderDto[]>;

  showOrderError: boolean = false;
  haveOrders: boolean;
  startDate = new Date();
  currency: string = '';

  isMobile: boolean;
  showTables = false;

  filterForm: FormGroup;
  moedas = Moedas;

  demeBanks$: Observable<string[]>;

  searchControl = new FormControl('');

  orderSourceOptions = [
    { value: 'HOMEBROKER', label: 'Plataforma' },
    { value: 'PARTNER', label: 'Parceiro' },
    { value: 'ADMIN', label: 'Operação' },
    { value: 'EXCHANGE', label: 'Exchange' },
  ];

  remmitanceTypeOptions = [
    { value: '1', label: 'Enviar' },
    { value: '0', label: 'Receber' },
  ];

  pendencyTypeOptions = [
    { value: 'all', label: 'Todas' },
    { value: 'payment_reproved', label: 'Ordem com pendência' },
    { value: 'pending_payment_info', label: 'Pendente informações de pagamento' },
    { value: 'pending_information', label: 'Pendente informações' },
    { value: 'pending_invoice_attachment', label: 'Invoice pendente' },
    { value: 'awaiting_quotation', label: 'Aguardando cotação' },
  ];

  private readonly pendencyTypeFlowMap: Record<string, EOrderStatusFlow[]> = {
    payment_reproved: [EOrderStatusFlow.PAYMENT_REPROVED],
    pending_payment_info: [EOrderStatusFlow.PENDING_PAYMENT_INFORMATION],
    pending_information: [
      EOrderStatusFlow.IDENTIFIED_PAYMENT_ABROAD,
      EOrderStatusFlow.PENDING_ORDER_INFORMATION,
    ],
    pending_invoice_attachment: [EOrderStatusFlow.PENDING_INVOICE_ATTACHMENT],
    awaiting_quotation: [EOrderStatusFlow.AVAILABLE_QUOTATION],
    all: [],
  };

  get filterFormControls() {
    return this.filterForm.controls;
  }

  get filter(): any {
    const filter = this.filterForm.value;
    return filter;
  }

  constructor(
    private readonly modalService: BoobleModalService,
    private readonly route: ActivatedRoute,
    private _location: Location,
    private readonly routeModalService: RouteModalService,
    notifierService: NotifierService,
    private readonly router: Router,
    private readonly ordersService: OrdersService,
    private readonly fb: FormBuilder,
    private readonly bankService: BankAccountService
  ) {
    this.notifier = notifierService;
    this.router.routeReuseStrategy.shouldReuseRoute = () => false;
  }

  ngOnInit() {
    this.initializeForm();

    this.pageSize = +sessionStorage.getItem('orders-history-page-size') || 10;

    this.tableDisplayedColumns = [
      'id',
      'clientInfo',
      'createdDate',
      'amount',
      'orderSource',
      'status',
      'slipCode',
      'action',
    ];

    this.route.paramMap.subscribe((params) => {
      const result = params.get('tenant');
      const rType = params.get('rType');

      if (result) this.tenant = params.get('tenant');
      if (rType) this.rType = params.get('rType');
    });

    this.routeModalService.verifyRouteParamsModal();

    this.isMobile = window.innerWidth <= 820 ? true : false;
    this.status = ``;

    this.ordersService.listenerUpdate.subscribe(() => {
      this.initializeWithPagination(
        this.status,
        null,
        this.pageNumber,
        this.pageSize
      );
    });
  }

  initializeForm() {
    this.filterForm = this.fb.group({
      statusFlow: [null],
      currency: [null],
      createdDate: [null],
      slipCode: [''],
      personType: [''],
      bankCurrencyTreasury: [''],
      value: [''],
      orderSource: [null],
      remmitanceType: [null],
      withSwift: [''],
      pendencyType: ['all'],
    });

    this.filterFormControls.currency.valueChanges.subscribe((currency) => {
      if (currency && currency.value) {
        this.currency = `${currency.value} `;

        this.demeBanks$ = this.bankService
          .getDemeBanks(currency.value)
          .pipe(
            map((v) =>
              v.data
                .filter((x) => x.remmitanceTypes.includes('OUTBOUND'))
                .map((x) => x.bankName)
            )
          );
      }
    });
  }

  onFilter() {
    this.pageNumber = 0;
    this.initializeWithPagination(
      this.status,
      null,
      this.pageNumber,
      this.pageSize
    );
  }

  onClearFilters() {
    this.filterForm.reset({
      statusFlow: null,
      currency: null,
      createdDate: null,
      slipCode: '',
      personType: '',
      bankCurrencyTreasury: '',
      value: '',
      orderSource: null,
      remmitanceType: null,
      withSwift: '',
      pendencyType: 'all',
    });

    this.searchControl.reset('');
    this.currency = '';
    this.demeBanks$ = null;
    this.pageNumber = 0;

    this.initializeWithPagination(
      this.status,
      null,
      this.pageNumber,
      this.pageSize
    );
  }

  initializeWithPagination(
    status: string,
    rType: string,
    page: number,
    pageSize: number
  ) {
    const filters = { ...this.filterForm.value };

    if (filters.currency) {
      filters.currency = filters.currency.value;
    }

    if (filters.createdDate) {
      filters.createdDate = filters.createdDate.toISOString().split('T')[0];
    }

    if (filters.id) {
      filters.id = filters.id.trim();
    }

    let computedStatus = status;
    if (filters.pendencyType) {
      const flows = this.pendencyTypeFlowMap[filters.pendencyType] || [];
      flows.forEach((f) => {
        computedStatus += `${computedStatus ? '&' : ''}flow=${f}`;
      });
    }
    delete filters.pendencyType;

    const searchValue = this.searchControl.value?.trim() || '';

    this.loading = true;
    this.showTables = false;
    this.haveOrders = false;

    this.orders = null;
    this.ordersService
      .getAdminByStatusFlowWithPagination(
        computedStatus,
        null,
        page + 1,
        pageSize,
        filters,
        searchValue
      )
      .subscribe({
        next: (result) => {
          this.loading = false;
          if (result.data.content.length > 0) {
            if (
              result.data.totalElements !== undefined &&
              result.data.totalElements !== null
            ) {
              this.totalElements = result.data.totalElements;
            }
            this.orders = result.data;
            this.haveOrders = true;
            this.showTables = true;
          } else {
            this.loading = false;
            this.haveOrders = false;
            this.showTables = false;
          }
        },
        error: () => {
          this.loading = false;
          this.showOrderError = true;
          this.haveOrders = false;
          this.showTables = false;
        },
      });
  }

  updatePageData({
    pageNumber,
    pageSize,
  }: {
    pageNumber: number;
    pageSize: number;
  }) {
    this.pageNumber = pageNumber;
    this.pageSize = pageSize;

    this.initializeWithPagination(this.status, null, pageNumber, pageSize);
  }

  changeTabStatus(event: MatTabChangeEvent) {
    const tabLabel = event.tab.textLabel;
    const mapping = tabMappingsHistoryAdmin[tabLabel];

    if (mapping) {
      this.tableTitle = mapping.tableTitle;
      this.status = mapping.statusRequest;
      this.tableDisplayedColumns = mapping.displayedColumns;

      if (tabLabel === 'Em andamento') {
        this.statusFlowOptions = Object.entries(ETableInProgressStatusFlow).map(
          ([key, value]) => ({
            value: key,
            label: value,
          })
        );
      } else if (tabLabel === 'Finalizadas') {
        this.statusFlowOptions = Object.entries(ETableFinishedStatusFlow).map(
          ([key, value]) => ({
            value: key,
            label: value,
          })
        );
      } else {
        this.statusFlowOptions = [
          ...Object.entries(ETableInProgressStatusFlow),
          ...Object.entries(ETableFinishedStatusFlow),
        ].map(([key, value]) => ({
          value: key,
          label: value,
        }));
      }

      this.onClearFilters();
    }
  }

  reloadPage() {
    window.location.reload();
  }

  openExchangeOrdersComponentModal(rType: string) {
    this.modalService.present(ExchangeOrdersComponent, rType);
  }

  openExchangeDocumentsCheckModal() {
    this.modalService.present(ExchangeDocumentsCheckComponent);
  }

  goBack() {
    this._location.back();
  }
}
